var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#535151",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7966 0.203182C17.6969 0.103059 17.5688 0.0359506 17.4297 0.0109185C17.2906 -0.0141137 17.1472 0.00413566 17.0188 0.0632025L0.404093 7.67829C0.264919 7.74201 0.150787 7.85006 0.0795479 7.98554C0.00830835 8.12102 -0.0160216 8.27629 0.0103631 8.42707C0.0367479 8.57784 0.112359 8.71562 0.225372 8.81886C0.338385 8.9221 0.482427 8.98497 0.634969 8.99764L8.35854 9.64146L9.00236 17.365C9.01503 17.5176 9.0779 17.6616 9.18114 17.7746C9.28438 17.8876 9.42216 17.9633 9.57293 17.9896C9.72371 18.016 9.87898 17.9917 10.0145 17.9205C10.1499 17.8492 10.258 17.7351 10.3217 17.5959L17.9368 0.981167C17.9956 0.852672 18.0137 0.709273 17.9886 0.570211C17.9635 0.431149 17.8965 0.303077 17.7966 0.203182ZM10.1628 14.619L9.68993 8.94233C9.67635 8.77913 9.60535 8.62603 9.48955 8.51024C9.37376 8.39444 9.22066 8.32344 9.05746 8.30986L3.38076 7.83696L15.9013 2.09851L10.1628 14.619Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.01308c1fc820bdb1d3528a24a62c5f0c.svg";
export { ForwardRef as ReactComponent };